import { BaseMarkerHandles } from '../base/baseMarkerHandles'
import { SquareHandle } from '../handles/squareHandle'
import type { RectangleMarker } from './rectangleMarker'
import type { Point } from '../../types'

export class RectangleMarkerHandles extends BaseMarkerHandles<RectangleMarker, SquareHandle> {
  handlePositions: Array<Point>

  getPressedHandleIndex(): number {
    return this.marker.state.handles.findIndex((handle) => handle === this.marker.state.pressedHandle)
  }

  updateHandlePostions(): void {
    this.marker.state.handles.forEach((handle, i) => {
      handle.position = this.handlePositions[i]
    })
  }

  populateHandlePositions(): void {
    const x = this.marker.state.position.x
    const y = this.marker.state.position.y
    const width = this.marker.state.dimensions.width
    const height = this.marker.state.dimensions.height

    this.handlePositions = [
      { x: x, y: y }, //Top-left
      { x: x + width, y: y }, //Top-right
      { x: x, y: y + height }, //Bottom-left
      { x: x + width, y: y + height }, //Bottom-right
    ]

    this.updateHandlePostions()
  }
  populate(): void {
    if (this.marker.state.handles.length === 0 && this.marker.isRectDefined()) {
      this.populateHandlePositions()
      this.marker.state.handles = this.handlePositions.map((position: Point) => {
        const handle = new SquareHandle(
          this.marker.p,
          position,
          this.marker.state.handleRadius,
          this.marker.state.handleStrokeWeight
        )
        return handle
      })
    }
  }
}
